import { IReparcelingSimulationsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisReparcelingSimulationsRepository from './implementations/VectisReparcelingSimulationsRepository';

let instance: IReparcelingSimulationsRepository | null = null;

export default function makeReparcelingSimulationsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisReparcelingSimulationsRepository(httpProvider);
  }

  return instance;
}
